import React, {useEffect, useState, useRef, useContext} from "react";
import axios from "./axios";
import CircularLoader from "./CircularLoader";
import {UserContext} from "./UserContext";
import {Select} from "antd";
import { Pagination } from 'antd';

const AlgebraKitQuestion = props => {
    const {mediaId} = props;
    const {user} = useContext(UserContext);
    const [activeSessionId, setActiveSessionId] = useState(undefined);
    const [selectedSessionId, setSelectedSessionId] = useState(undefined);
    const [mediaResult, setMediaResult] = useState(undefined);
    const [aKitPageInfo, setAKitPageInfo] = useState(undefined);
    const [classId, setClassId] = useState();
    const [students, setStudents] = useState([]);
    const [studentId, setStudentId] = useState();
    const [isLoading, setLoading] = useState(true);
    const [isLoadingExercise, setLoadingExercise] = useState(false);
    const [isLoadingHistory, setLoadingHistory] = useState(true);
    const [isError, setError] = useState(false);
    const akitRef = useRef();
    const pageSize = 1;

    function loadPage(pageNum) {
        if (activeSessionId && pageNum === aKitPageInfo.totalResults) {
            setAKitPageInfo(Object.assign({}, aKitPageInfo, {
                currPage: aKitPageInfo.totalPages
            }));
            loadSession(activeSessionId);
            setMediaResult(undefined);
        } else {
            loadHistory(pageNum);
        }
    }
    function loadSession(sessionId) {
        if (!sessionId) {
            return;
        }
        console.log('loadSession');

        if (sessionId === -1) {
            akitRef.current.innerHTML = '';
            loadAlgebraKitExercise();
        } else {
            setLoadingExercise(true);
            akitRef.current.innerHTML = '<akit-exercise session-id="' + sessionId + '"></akit-exercise>';
            setLoading(false);
            setSelectedSessionId(sessionId);
        }
    }

    function loadHistory(pageNum) {
        if (!mediaId) {
            return;
        }
        console.log('loadHistory', pageNum);

        setLoadingHistory(true);
        let url = "/web/media/akit/exercise/history/" + mediaId;
        if (studentId) url += "/" + studentId;
        axios.get(url, {params: {pageNumber: pageNum, pageSize: pageSize}})
            .then(response => {
                setAKitPageInfo(response.data);
                if (studentId === undefined) {
                    if (response.data.totalResults > 0) {
                        const mediaResult = response.data.currPageContents[0];
                        setMediaResult(mediaResult);
                        if (mediaResult.resultStatus !== 'COMPLETED' && response.data.currPage === response.data.totalPages) {
                            setActiveSessionId(mediaResult.sessionId);
                        }
                        loadSession(mediaResult.sessionId);
                    } else {
                        setMediaResult(undefined);
                        loadAlgebraKitExercise();
                    }
                } else {
                    if (response.data.totalResults > 0) {
                        const mediaResult = response.data.currPageContents[0];
                        setMediaResult(mediaResult);
                        setActiveSessionId(undefined);
                        loadSession(mediaResult.sessionId);
                    } else {
                        setMediaResult(undefined);
                        akitRef.current.innerHTML = '<span class="ch-warning-text">No attempts recorded</span>';
                    }
                }
                setLoadingHistory(false);
            })
                .catch(error => {
                console.log('ERROR', error);
                setError(true);
                setLoadingHistory(false);
            });
    }


    function loadAlgebraKitExercise() {
        setLoading(true);
        axios.get("/web/media/akit/exercise/view/" + mediaId, {params: {pageSize: pageSize}})
            .then(response => {
                setLoading(false);
                setLoadingExercise(true);
                setAKitPageInfo(response.data.pageInfo);
                if (response.data.pageInfo.totalResults > 0) {
                    const mediaResult = response.data.pageInfo.currPageContents[0];
                    setMediaResult(mediaResult);
                    if (mediaResult.resultStatus !== 'COMPLETED' && response.data.pageInfo.currPage === response.data.pageInfo.totalPages) {
                        setActiveSessionId(mediaResult.sessionId);
                    }
                    loadSession(mediaResult.sessionId);
                }
            }).catch(error => {
                setLoading(false);
                setLoadingExercise(false);
                setError(true);
                akitRef.current.innerHTML = "Error loading question."
            });
    }

    function updateAlgebraKitExercise(params, callback) {
        axios.post("/web/media/akit/exercise/update", params)
            .then(response => {
                if (response.data) {
                    setMediaResult(response.data);
                    if (response.data.resultStatus === 'COMPLETED') {
                        setActiveSessionId(undefined);
                    }
                } else {
                    setError(true);
                }
                if (typeof callback === 'function') callback();
            }).catch(error => {
                console.log('ERROR', error);
                setError(true);
            });
    }

    const handleOnChangeClass = classId => {
        if(classId == -1) {
            setClassId(undefined);
        } else {
            setClassId(classId);
        }
    }

    const handleOnChangeStudent = studentId => {
        if(studentId == -1) {
            setStudentId(undefined)
            loadAlgebraKitExercise();
        } else {
            setStudentId(studentId);
        }
    }

    useEffect(() => {
        if (!user.student && classId != undefined) {
            setLoadingHistory(true);
            axios.get('/web/ui/sc/studentsInClass', {params: {classId: classId}})
                .then(response => {
                    if (response.data) {
                        setStudents(response.data);
                        if (response.data.length == 0) {
                            setStudentId(undefined);
                        }
                    } else {
                        setStudents([]);
                        setStudentId(undefined);
                    }
                    setLoadingHistory(false);
                }).catch(error => {
                    console.log('ERROR', error);
                    setLoadingHistory(false);
                });
        } else {
            setStudents([]);
            setStudentId(undefined);
        }
    }, [classId]);

    useEffect(() => {
        loadPage();
    }, [studentId]);

    useEffect(() => {
        if(activeSessionId == undefined || mediaId == undefined) {
            return;
        }

        let params = {
            sessionId: activeSessionId,
            mediaId: mediaId
        };

        const eventHandler = (eventData) => {
            if (eventData.event === "interaction-evaluate") {
                console.log('interaction-evaluate event');
                params.mark = eventData.data.scoring.marksEarned;
                params.maxMark = eventData.data.scoring.marksTotal;
                updateAlgebraKitExercise(params);
            } else if (eventData.event === "exercise-finished") {
                console.log('exercise-finished event');
                params.completed = true;
                updateAlgebraKitExercise(params, function () {
                    // loadAlgebraKitExercise();
                });
            } else if (eventData.event === "exercise-created") {
                setLoading(false);
                setLoadingExercise(false);
            }
        };

        if (typeof AlgebraKIT !== 'undefined') {
            AlgebraKIT.addExerciseListener(params.sessionId, eventHandler);
        }

        return () => {
            if (typeof AlgebraKIT !== 'undefined') {
                AlgebraKIT.removeExerciseListener(params.sessionId, eventHandler);
            }
        };
    }, [activeSessionId, mediaId]);

    useEffect(() => {
        if(selectedSessionId == undefined || mediaId == undefined) {
            return;
        }

        const eventHandler = (eventData) => {
            console.log('eventData', eventData);
            setLoading(false);
            setLoadingExercise(false);
        };

        if (typeof AlgebraKIT !== 'undefined') {
            AlgebraKIT.addExerciseListener(selectedSessionId, eventHandler);
        }

        return () => {
            if (typeof AlgebraKIT !== 'undefined') {
                AlgebraKIT.removeExerciseListener(selectedSessionId, eventHandler);
            }
        };
    }, [selectedSessionId, mediaId]);

    const teacherView = user && !user.student;

    return (
        <div className={"akit-blk margin-t--l" + (teacherView ? " akit-blk-teacherView" : "")}>
            <div className="akit-main-panel">
                {aKitPageInfo && (
                    <h3 className="akit-head">Question {aKitPageInfo.currPage}</h3>
                )}
                <div className="akit-history">
                    {aKitPageInfo && aKitPageInfo.totalResults > 0 ? (
                        <>
                            {mediaResult && mediaResult.completed ? (
                                <p className="text-muted">Date completed:  {mediaResult.markDate ? user.dateTimeFormat.format(mediaResult.markDate) : ''}</p>
                            ) : (
                                <p className="text-muted">Current question</p>
                            )}
                            <CircularLoader className="align-center" visible={isLoadingHistory} pageCentered={true} displayInElement={true} spacing={true}/>
                            {!isLoadingHistory && (
                                <Pagination
                                    className="ch-paging margin-t--l"
                                    current={aKitPageInfo.currPage}
                                    pageSize={aKitPageInfo.pageSize}
                                    total={aKitPageInfo.totalResults}
                                    onChange={(page) => {
                                        loadPage(page);
                                    }}
                                />
                            )}
                        </>
                    ) : (
                        <div className="ch-warning-text">No attempts recorded</div>
                    )}
                </div>
                <div className="akit-main">
                    <CircularLoader visible={isLoading || isLoadingExercise} pageCentered={false} spacing={true}/>
                    <div ref={akitRef}></div>
                    {!isLoading && studentId == undefined && activeSessionId == undefined && (
                        <div className="btn-blk align-right">
                            <button className="ch-button ch-btn" onClick={() => loadSession(-1)}>New question</button>
                        </div>
                    )}
                </div>
            </div>
            <div className="akit-options-panel">
                {teacherView && (
                    <div className="akit-techer-options">
                        <div className="flexColumn">
                            <h3>My Classes</h3>
                            {user.classes && user.classes.length == 0 && (
                                <div className="ch-warning-text">No assigned classes</div>
                            )}
                            {user.classes && user.classes.length > 0 &&
                                <div>
                                    <Select defaultValue={classId != undefined  ? classId : -1}
                                            popupMatchSelectWidth={200}
                                            onChange={handleOnChangeClass} virtual={false} showSearch={false}>
                                        <Select.Option key={-1} value={-1}>select a class</Select.Option>
                                        {user.classes.map((clazz) => {
                                            return <Select.Option key={clazz.classId}
                                                                  value={clazz.classId}>{clazz.className}</Select.Option>;
                                        })}
                                    </Select>
                                    {students && students.length > 0 &&
                                        <>
                                            <h4>View results for:</h4>
                                            <Select popupMatchSelectWidth={200}
                                                    defaultValue={studentId != undefined ? studentId : -1}
                                                    onChange={handleOnChangeStudent} showSearch={true}>
                                                <Select.Option key={-1} value={-1}>Me</Select.Option>
                                                {students.map((student) => {
                                                    return <Select.Option key={student.userId} value={student.userId}>{student.firstName} {student.lastName}</Select.Option>;
                                                })}
                                            </Select>
                                        </>
                                    }
                                    {classId == undefined &&
                                        <div className="ch-warning-text">No class selected</div>
                                    }
                                    {classId != undefined && students && students.length == 0 &&
                                        <div className="ch-warning-text">No students in class</div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default AlgebraKitQuestion;